import { render, staticRenderFns } from "./ClientTable.vue?vue&type=template&id=d004a73e&scoped=true&"
import script from "./ClientTable.vue?vue&type=script&lang=js&"
export * from "./ClientTable.vue?vue&type=script&lang=js&"
import style0 from "./ClientTable.vue?vue&type=style&index=0&id=d004a73e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d004a73e",
  null
  
)

export default component.exports